import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalPageLuxe from './LegalPageLuxe';

// Texte du fondateur (docs/legal, 2026-10-30), dans legal.json (mentions.sections, tableau de sections).
// Nom et prenom de l'editeur OBLIGATOIRES (personne physique : LCEN art. 6 III, et mention « EI » du Code de commerce) :
// le nom commercial NCVTC s'y ajoute, il ne les remplace pas. SIRET verifie dans l'annuaire des entreprises.
export default function MentionsLegalesLuxe() {
  const { t } = useTranslation('legal');
  const sections = t('mentions.sections', { returnObjects: true });
  return (
    <LegalPageLuxe
      title={t('mentions.title')}
      updated={t('mentions.updated')}
      intro={t('mentions.intro')}
      sections={Array.isArray(sections) ? sections : []}
    />
  );
}
